/*
 * Cost-per-unit inclusion list.
 *
 * Single-variant product SKUs that SHOULD show "Cost per unit" on the product page,
 * even though single-variant products are skipped by default. This is the inverse of
 * the exceptionSkus list in snippets/product-variant-selector.liquid.
 *
 * How it is used: snippets/product-variant-selector.liquid loads this file and reads
 * window.pricePerUnitIncludeSkus inside updateCostPerUnitDisplay().
 *
 * Rules:
 *   - One SKU per line, wrapped in quotes, comma-separated.
 *   - SKUs are matched case-sensitively and must equal the variant SKU exactly.
 *   - The cost-per-unit still only shows when the SKU also ends in -<number>ea
 *     (e.g. -2EA), which is the pattern the calculation reads.
 *
 * Generated from sku-inclusion-list.csv (1233 SKUs). To update, edit this file
 * directly, or regenerate from an updated CSV.
 */
window.pricePerUnitIncludeSkus = [
  'BVBNA161NLF0125-6EA',
  'BVBNA161NLF0150-4EA',
  'BVBNA161NLF0200-4EA',
  'BVBNA161NLF0300-2EA',
  'BVBNA161NLF050-10EA',
  'BVBNA161NLF050-50EA',
  'BVBNA161NLF075-10EA',
  'BVBNA161NLF075-25EA',
  'BVBNA161NLF100-10EA',
  'BVBNA161NLF100-5EA',
  'BVBNA161NLF125-5EA',
  'BVBNA161NLF150-2EA',
  'BVBNA171N0200-4EA',
  'BVBNA171N0300-4EA',
  'BVBNA171N0400-2EA',
  'BVBNA171NLF0100-20EA',
  'BVBNA171NLF0100-5EA',
  'BVBNA171NLF0125-2EA',
  'BVBNA171NLF0125-6EA',
  'BVBNA171NLF0150-4EA',
  'BVBNA171NLF0200-4EA',
  'BVBNA171NLF050-10EA',
  'BVBNA171NLF075-25EA',
  'BVBNA171NLF075-5EA',
  'BVBNA700LL0050-5EA',
  'BVJ100080RVSSG-2EA',
  'BVJ100100RVSSG-2EA',
  'BVJ100101SSG-10EA',
  'BVJ100101SSG-6EA',
  'BVJ100101SSGLH-10EA',
  'BVJ100101SSGLH-6EA',
  'BVJ100102SSG-10EA',
  'BVJ100102SSG-6EA',
  'BVJ100102SSGLH-10EA',
  'BVJ100102SSGLH-6EA',
  'BVJ100103JFPG-10EA',
  'BVJ100103JFPG-3EA',
  'BVJ100103SSG-10EA',
  'BVJ100103SSG-5EA',
  'BVJ100103SSGLH-10EA',
  'BVJ100103SSGLH-5EA',
  'BVJ100104JFPG-2EA',
  'BVJ100104JFPG-5EA',
  'BVJ100104SSG-10EA',
  'BVJ100104SSG-3EA',
  'BVJ100104SSGLH-10EA',
  'BVJ100104SSGLH-3EA',
  'BVJ100105JFPG-2EA',
  'BVJ100105SSG-2EA',
  'BVJ100105SSG-8EA',
  'BVJ100105SSGLH-2EA',
  'BVJ100105SSGLH-8EA',
  'BVJ100106SSG-2EA',
  'BVJ100106SSG-4EA',
  'BVJ100106SSGLH-2EA',
  'BVJ100106SSGLH-4EA',
  'BVJ100107SSG-2EA',
  'BVJ100113SSG-10EA',
  'BVJ100113SSG-5EA',
  'BVJ100113SSGLH-10EA',
  'BVJ100113SSGLH-5EA',
  'BVJ100114SSG-10EA',
  'BVJ100114SSG-3EA',
  'BVJ100114SSGLH-10EA',
  'BVJ100114SSGLH-3EA',
  'BVJ100115SSG-2EA',
  'BVJ100115SSG-8EA',
  'BVJ100115SSGLH-2EA',
  'BVJ100115SSGLH-8EA',
  'BVJ100116SSG-2EA',
  'BVJ100116SSG-4EA',
  'BVJ100116SSGLH-2EA',
  'BVJ100116SSGLH-4EA',
  'BVJ100117SSG-2EA',
  'BVJ100125RVSSG-2EA',
  'BVJ100131G-10EA',
  'BVJ100131G-5EA',
  'BVJ100132G-10EA',
  'BVJ100132G-5EA',
  'BVJ100133G-10EA',
  'BVJ100133G-4EA',
  'BVJ100134G-10EA',
  'BVJ100134G-3EA',
  'BVJ100135G-2EA',
  'BVJ100135G-8EA',
  'BVJ100203G-10EA',
  'BVJ100203G-3EA',
  'BVJ100203GLH-10EA',
  'BVJ100203GLH-2EA',
  'BVJ100203SSG-10EA',
  'BVJ100203SSG-2EA',
  'BVJ100203SSGLH-10EA',
  'BVJ100203SSGLH-2EA',
  'BVJ100204G-10EA',
  'BVJ100204G-3EA',
  'BVJ100204GLH-10EA',
  'BVJ100204GLH-2EA',
  'BVJ100205G-2EA',
  'BVJ100205G-6EA',
  'BVJ100205GLH-6EA',
  'BVJ100396G-25EA',
  'BVJ100396G-8EA',
  'BVJ100397G-25EA',
  'BVJ100397G-8EA',
  'BVJ100397THG-25EA',
  'BVJ100397THG-8EA',
  'BVJ100398G-20EA',
  'BVJ100398G-8EA',
  'BVJ100398THG-20EA',
  'BVJ100398THG-8EA',
  'BVJ100399G-25EA',
  'BVJ100399G-8EA',
  'BVJ100399THG-25EA',
  'BVJ100399THG-8EA',
  'BVJ100400G-20EA',
  'BVJ100400G-8EA',
  'BVJ100403G-12EA',
  'BVJ100403G-5EA',
  'BVJ100403GIH-12EA',
  'BVJ100403GIH-2EA',
  'BVJ100403GLH-12EA',
  'BVJ100403GLH-4EA',
  'BVJ100403SSG-12EA',
  'BVJ100403SSG-3EA',
  'BVJ100403SSGIH-12EA',
  'BVJ100403SSGIH-2EA',
  'BVJ100403SSGLH-12EA',
  'BVJ100403SSGLH-3EA',
  'BVJ100404G-12EA',
  'BVJ100404G-3EA',
  'BVJ100404GIH-12EA',
  'BVJ100404GIH-2EA',
  'BVJ100404GLH-12EA',
  'BVJ100404GLH-3EA',
  'BVJ100404SSG-12EA',
  'BVJ100404SSG-2EA',
  'BVJ100404SSGIH-12EA',
  'BVJ100404SSGLH-12EA',
  'BVJ100404SSGLH-2EA',
  'BVJ100405G-2EA',
  'BVJ100405G-6EA',
  'BVJ100405GIH-6EA',
  'BVJ100405GLH-2EA',
  'BVJ100405GLH-6EA',
  'BVJ100405SSG-2EA',
  'BVJ100405SSG-6EA',
  'BVJ100405SSGLH-6EA',
  'BVJ100406G-2EA',
  'BVJ100406G-4EA',
  'BVJ100406GLH-4EA',
  'BVJ100413G-12EA',
  'BVJ100413G-6EA',
  'BVJ100413GIH-12EA',
  'BVJ100413GIH-2EA',
  'BVJ100413GLH-12EA',
  'BVJ100413GLH-4EA',
  'BVJ100413SSG-12EA',
  'BVJ100413SSG-3EA',
  'BVJ100413SSGIH-10EA',
  'BVJ100413SSGIH-2EA',
  'BVJ100413SSGLH-12EA',
  'BVJ100413SSGLH-3EA',
  'BVJ100414G-12EA',
  'BVJ100414G-3EA',
  'BVJ100414GIH-12EA',
  'BVJ100414GIH-2EA',
  'BVJ100414GLH-12EA',
  'BVJ100414GLH-3EA',
  'BVJ100414SSG-12EA',
  'BVJ100414SSG-2EA',
  'BVJ100414SSGIH-12EA',
  'BVJ100414SSGLH-12EA',
  'BVJ100414SSGLH-2EA',
  'BVJ100415G-2EA',
  'BVJ100415G-6EA',
  'BVJ100415GIH-6EA',
  'BVJ100415GLH-2EA',
  'BVJ100415GLH-6EA',
  'BVJ100415SSG-2EA',
  'BVJ100415SSG-6EA',
  'BVJ100415SSGLH-6EA',
  'BVJ100416G-2EA',
  'BVJ100416G-4EA',
  'BVJ100416GLH-4EA',
  'BVJ100633G-10EA',
  'BVJ100633G-5EA',
  'BVJ100634G-10EA',
  'BVJ100634G-3EA',
  'BVJ100635G-2EA',
  'BVJ100635G-6EA',
  'BVJ100643G-10EA',
  'BVJ100643G-5EA',
  'BVJ100644G-10EA',
  'BVJ100644G-3EA',
  'BVJ100645G-2EA',
  'BVJ100645G-8EA',
  'BVJ100653G-10EA',
  'BVJ100653G-3EA',
  'BVJ100654G-10EA',
  'BVJ100654G-2EA',
  'BVJ100663G-10EA',
  'BVJ100663G-3EA',
  'BVJ100664G-10EA',
  'BVJ100664G-3EA',
  'BVJ100673G-10EA',
  'BVJ100673G-3EA',
  'BVJ100674G-10EA',
  'BVJ100674G-2EA',
  'BVJ100753G-12EA',
  'BVJ100753G-3EA',
  'BVJ100754G-10EA',
  'BVJ100754G-2EA',
  'BVJ100773G-10EA',
  'BVJ100773G-2EA',
  'BVJ100774G-10EA',
  'BVJ100774G-2EA',
  'BVJ100833G-2EA',
  'BVJ100833G-4EA',
  'BVJ100834G-2EA',
  'BVJ100834G-4EA',
  'BVJ100903-3EA',
  'BVJ100903-5EA',
  'BVJ100904-2EA',
  'BVJ100904-4EA',
  'BVJ100905-2EA',
  'BVJ100906-2EA',
  'BVJ100931-10EA',
  'BVJ100931-2EA',
  'BVJ100932-10EA',
  'BVJ100932-2EA',
  'BVJ100933-10EA',
  'BVJ100933-2EA',
  'BVJ100934-10EA',
  'BVJ100934-2EA',
  'BVJ100951-10EA',
  'BVJ100951-2EA',
  'BVJ100952-10EA',
  'BVJ100952-2EA',
  'BVJ100953-10EA',
  'BVJ100953-2EA',
  'BVJ100954-10EA',
  'BVJ100954-2EA',
  'BVJ100955-10EA',
  'BVJ100955-2EA',
  'BVJ100961-10EA',
  'BVJ100961-2EA',
  'BVJ100962-10EA',
  'BVJ100962-2EA',
  'BVJ100963-10EA',
  'BVJ100963-2EA',
  'BVJ100964-10EA',
  'BVJ100964-2EA',
  'BVJ100965-10EA',
  'BVJ100971-10EA',
  'BVJ100971-3EA',
  'BVJ100972-10EA',
  'BVJ100972-3EA',
  'BVJ100973-10EA',
  'BVJ100973-2EA',
  'BVJ100974-10EA',
  'BVJ100974-2EA',
  'BVJ101080RVSSG-2EA',
  'BVJ101100RVSSG-2EA',
  'BVJ101125RVSSG-2EA',
  'BVJ101401-12EA',
  'BVJ101401-6EA',
  'BVJ101402-12EA',
  'BVJ101402-6EA',
  'BVJ101403-12EA',
  'BVJ101403-7EA',
  'BVJ101403DU-4EA',
  'BVJ101404-12EA',
  'BVJ101404-4EA',
  'BVJ101404BRT-3EA',
  'BVJ101404BRT-6EA',
  'BVJ101404DU-2EA',
  'BVJ101404DU-8EA',
  'BVJ101411-12EA',
  'BVJ101411-6EA',
  'BVJ101412-12EA',
  'BVJ101412-6EA',
  'BVJ101413-12EA',
  'BVJ101413-7EA',
  'BVJ101414-12EA',
  'BVJ101414-4EA',
  'BVJ101502-14EA',
  'BVJ101502-5EA',
  'BVJ101503-14EA',
  'BVJ101503-5EA',
  'BVJ101504-4EA',
  'BVJ101504-8EA',
  'BVJ101512-14EA',
  'BVJ101512-5EA',
  'BVJ101513-14EA',
  'BVJ101513-5EA',
  'BVJ101513DU-4EA',
  'BVJ101513DU-8EA',
  'BVJ101601-12EA',
  'BVJ101601-5EA',
  'BVJ101602-12EA',
  'BVJ101602-6EA',
  'BVJ101603-12EA',
  'BVJ101603-6EA',
  'BVJ101604-4EA',
  'BVJ101604-8EA',
  'BVJ101612-12EA',
  'BVJ101612-5EA',
  'BVJ101613-12EA',
  'BVJ101613-5EA',
  'BVJ101614-4EA',
  'BVJ101614-8EA',
  'BVJ101702-12EA',
  'BVJ101703-12EA',
  'BVJ101703DU-4EA',
  'BVJ101703DU-6EA',
  'BVJ101704DU-2EA',
  'BVJ101704DU-8EA',
  'BVJ101803DU-3EA',
  'BVJ101803DU-4EA',
  'BVJ101803DU-5EA',
  'BVJ101804DU-8EA',
  'BVJ101931-10EA',
  'BVJ101931-2EA',
  'BVJ101933-10EA',
  'BVJ101933-2EA',
  'BVJ102301-10EA',
  'BVJ102301-4EA',
  'BVJ102302-10EA',
  'BVJ102302-4EA',
  'BVJ102303-10EA',
  'BVJ102303-4EA',
  'BVJ102303DU-6EA',
  'BVJ102304-3EA',
  'BVJ102304-8EA',
  'BVJ102304DU-4EA',
  'BVJ102313DU-4EA',
  'BVJ102314DU-3EA',
  'BVJ102314DU-6EA',
  'BVJ102402-12EA',
  'BVJ102402-4EA',
  'BVJ102403-12EA',
  'BVJ102403-4EA',
  'BVJ102403DU-3EA',
  'BVJ102403DU-6EA',
  'BVJ102404-3EA',
  'BVJ102404-8EA',
  'BVJ102405-10EA',
  'BVJ102405-3EA',
  'BVJ102413DU-3EA',
  'BVJ102413DU-6EA',
  'BVJ102503-14EA',
  'BVJ102503-7EA',
  'BVJ102504-10EA',
  'BVJ102504-5EA',
  'BVJ102505-10EA',
  'BVJ102505-3EA',
  'BVJ102513-12EA',
  'BVJ102513-7EA',
  'BVJ102514-10EA',
  'BVJ102514-5EA',
  'BVJ102603-10EA',
  'BVJ102603-8EA',
  'BVJ102604-10EA',
  'BVJ102604-5EA',
  'BVJ102605-4EA',
  'BVJ102605-6EA',
  'BVJ102612-10EA',
  'BVJ102612-8EA',
  'BVJ102613-10EA',
  'BVJ102613-7EA',
  'BVJ102614-10EA',
  'BVJ102614-5EA',
  'BVJ102623-10EA',
  'BVJ102623-8EA',
  'BVJ102624-10EA',
  'BVJ102624-5EA',
  'BVJ102625-4EA',
  'BVJ102625-6EA',
  'BVJ102633-10EA',
  'BVJ102633-7EA',
  'BVJ102653G-10EA',
  'BVJ102653G-4EA',
  'BVJ102654G-10EA',
  'BVJ102654G-3EA',
  'BVJ102655G-2EA',
  'BVJ102655G-6EA',
  'BVJ103080RVSSG-2EA',
  'BVJ103100RVSSG-2EA',
  'BVJ103125RVSSG-2EA',
  'BVJ103523PG-10EA',
  'BVJ103523PGTH-10EA',
  'BVJ103524PG-10EA',
  'BVJ103524PG-6EA',
  'BVJ103524PGTH-5EA',
  'BVJ103525PG-4EA',
  'BVJ103525PG-6EA',
  'BVJ103525PGTH-4EA',
  'BVJ103526PG-10EA',
  'BVJ103526PG-2EA',
  'BVJ103527PG-2EA',
  'BVJ103527PG-4EA',
  'BVJ103528PG-2EA',
  'BVJ103533PG-10EA',
  'BVJ103533PG-6EA',
  'BVJ103533PGTH-7EA',
  'BVJ103534MPG-10EA',
  'BVJ103534MPG-3EA',
  'BVJ103534MPGTH-4EA',
  'BVJ103534PG-10EA',
  'BVJ103534PG-4EA',
  'BVJ103534PGTH-5EA',
  'BVJ103535PG-3EA',
  'BVJ103535PG-6EA',
  'BVJ103535PGTH-3EA',
  'BVJ103543PG-10EA',
  'BVJ103543PG-5EA',
  'BVJ103543PGTH-6EA',
  'BVJ103544PG-10EA',
  'BVJ103544PG-4EA',
  'BVJ103544PGTH-5EA',
  'BVJ103554PG-10EA',
  'BVJ103554PG-5EA',
  'BVJ103554PGTH-5EA',
  'BVJ103555PG-3EA',
  'BVJ103555PG-6EA',
  'BVJ103555PGTH-3EA',
  'BVJ103563PG-10EA',
  'BVJ103563PG-4EA',
  'BVJ103564PG-10EA',
  'BVJ103564PG-3EA',
  'BVJ103565PG-2EA',
  'BVJ103565PG-8EA',
  'BVJ104080RVSSG-2EA',
  'BVJ104100RVSSG-2EA',
  'BVJ104125RVSSG-2EA',
  'BVJ104523PG-10EA',
  'BVJ104523PG-7EA',
  'BVJ104523PGTH-6EA',
  'BVJ104524PG-10EA',
  'BVJ104524PG-5EA',
  'BVJ104524PGTH-5EA',
  'BVJ104525PG-3EA',
  'BVJ104525PG-6EA',
  'BVJ104525PGTH-3EA',
  'BVJ104526PG-2EA',
  'BVJ104526PG-6EA',
  'BVJ104527PG-2EA',
  'BVJ104527PG-4EA',
  'BVJ104533-10EA',
  'BVJ104533-5EA',
  'BVJ104533PGTH-6EA',
  'BVJ104534-10EA',
  'BVJ104534-4EA',
  'BVJ104534MPG-10EA',
  'BVJ104534MPG-4EA',
  'BVJ104534MPGTH-5EA',
  'BVJ104534PGTH-5EA',
  'BVJ104535-10EA',
  'BVJ104535-3EA',
  'BVJ104543PG-10EA',
  'BVJ104543PG-5EA',
  'BVJ104543PGTH-6EA',
  'BVJ104544PG-10EA',
  'BVJ104544PG-3EA',
  'BVJ104544PGTH-4EA',
  'BVJ104545PG-10EA',
  'BVJ104545PG-3EA',
  'BVJ104554PG-10EA',
  'BVJ104554PG-4EA',
  'BVJ104554PGTH-5EA',
  'BVJ104555PG-3EA',
  'BVJ104555PG-6EA',
  'BVJ104555PGTH-3EA',
  'BVJ104563PG-10EA',
  'BVJ104563PG-4EA',
  'BVJ104564PG-10EA',
  'BVJ104564PG-3EA',
  'BVJ104565PG-10EA',
  'BVJ104565PG-2EA',
  'BVJ113524PG-10EA',
  'BVJ113525PG-6EA',
  'BVJ113533PG-10EA',
  'BVJ113534MPG-10EA',
  'BVJ113534PG-10EA',
  'BVJ113535PG-6EA',
  'BVJ113543PG-10EA',
  'BVJ113544PG-10EA',
  'BVJ113554PG-10EA',
  'BVJ113555PG-6EA',
  'BVJ114523PG-10EA',
  'BVJ114524PG-10EA',
  'BVJ114525PG-6EA',
  'BVJ114533PG-10EA',
  'BVJ114534MPG-10EA',
  'BVJ114534PG-10EA',
  'BVJ114543PG-10EA',
  'BVJ114544PG-10EA',
  'BVJ114554PG-10EA',
  'BVJ114555PG-6EA',
  'BVJ150103G-10EA',
  'BVJ150103G-6EA',
  'BVJ150104G-4EA',
  'BVJ150104G-8EA',
  'BVJ150105G-3EA',
  'BVJ150105G-6EA',
  'BVJ150106G-2EA',
  'BVJ150107G-2EA',
  'BVJ150113G-10EA',
  'BVJ150113G-7EA',
  'BVJ150114G-4EA',
  'BVJ150114G-8EA',
  'BVJ150115G-3EA',
  'BVJ150115G-6EA',
  'BVJ150116G-2EA',
  'BVJ150117G-2EA',
  'BVJ150203G-10EA',
  'BVJ150203G-4EA',
  'BVJ150204G-10EA',
  'BVJ150204G-3EA',
  'BVJ150205G-2EA',
  'BVJ150205G-6EA',
  'BVJ150233G-10EA',
  'BVJ150233G-3EA',
  'BVJ150234G-10EA',
  'BVJ150234G-2EA',
  'BVJ150235G-2EA',
  'BVJ150235G-8EA',
  'BVJ150563G-10EA',
  'BVJ150563G-4EA',
  'BVJ150564G-10EA',
  'BVJ150564G-3EA',
  'BVJ150565G-2EA',
  'BVJ150565G-8EA',
  'BVJ150573G-10EA',
  'BVJ150573G-4EA',
  'BVJ150574G-10EA',
  'BVJ150574G-3EA',
  'BVJ150575G-2EA',
  'BVJ150575G-8EA',
  'BVJ150603G-3EA',
  'BVJ150603G-6EA',
  'BVJ150604G-2EA',
  'BVJ150604G-4EA',
  'BVJ150605G-2EA',
  'BVJ150663G-3EA',
  'BVJ150663G-6EA',
  'BVJ150664G-2EA',
  'BVJ150664G-4EA',
  'BVJ150665G-2EA',
  'BVJ210203-20EA',
  'BVJ210203-30EA',
  'BVJ210204-15EA',
  'BVJ210204-20EA',
  'BVJ210205-12EA',
  'BVJ210205-16EA',
  'BVJ210206-10EA',
  'BVJ210206-15EA',
  'BVJ210207-6EA',
  'BVJ210207-8EA',
  'BVJ210208-5EA',
  'BVJ210208-8EA',
  'BVJ210209-2EA',
  'BVJ210209-4EA',
  'BVJ210210-6EA',
  'BVJ210223-20EA',
  'BVJ210223-30EA',
  'BVJ210224-15EA',
  'BVJ210224-20EA',
  'BVJ210225-12EA',
  'BVJ210225-16EA',
  'BVJ210226-10EA',
  'BVJ210226-15EA',
  'BVJ210227-6EA',
  'BVJ210227-8EA',
  'BVJ210228-5EA',
  'BVJ210228-8EA',
  'BVJ210229-2EA',
  'BVJ210229-4EA',
  'BVJ210230-6EA',
  'BVJ210543-48EA',
  'BVJ210543-7EA',
  'BVJ210544-36EA',
  'BVJ210544-6EA',
  'BVJ210545-24EA',
  'BVJ210545-4EA',
  'BVJ210546-24EA',
  'BVJ210546-3EA',
  'BVJ210547-24EA',
  'BVJ210547-2EA',
  'BVJ210548-12EA',
  'BVJ210548-2EA',
  'BVJ210603-10EA',
  'BVJ210603-20EA',
  'BVJ210604-15EA',
  'BVJ210604-9EA',
  'BVJ210605-8EA',
  'BVJ210606-10EA',
  'BVJ210606-5EA',
  'BVJ210607-4EA',
  'BVJ210608-4EA',
  'BVJ210703-20EA',
  'BVJ210703-30EA',
  'BVJ210704-15EA',
  'BVJ210704-20EA',
  'BVJ210705-12EA',
  'BVJ210705-20EA',
  'BVJ210706-10EA',
  'BVJ210706-20EA',
  'BVJ210707-12EA',
  'BVJ210707-6EA',
  'BVJ210708-6EA',
  'BVJ210723-20EA',
  'BVJ210723-30EA',
  'BVJ210724-15EA',
  'BVJ210724-20EA',
  'BVJ210725-12EA',
  'BVJ210725-20EA',
  'BVJ210726-10EA',
  'BVJ210726-20EA',
  'BVJ210727-12EA',
  'BVJ210727-6EA',
  'BVJ210728-6EA',
  'BVJ240003B-10EA',
  'BVJ240003P-10EA',
  'BVJ240004B-10EA',
  'BVJ240004P-10EA',
  'BVJ240004T-10EA',
  'BVJ240005B-6EA',
  'BVJ240005P-6EA',
  'BVJ240005T-6EA',
  'BVJ241004D-5EA',
  'BVJ241004P-5EA',
  'BVJ241004T-5EA',
  'BVJ242005B-6EA',
  'BVJ242005P-6EA',
  'BVJ243004D-4EA',
  'BVJ243004EXT-16EA',
  'BVJ243204B-4EA',
  'BVJ244005B-5EA',
  'BVJ244005P-5EA',
  'BVJ246005B-6EA',
  'BVJ500098-10EA',
  'BVJ500098-2EA',
  'BVJ500099-10EA',
  'BVJ500099-2EA',
  'BVJ500101-10EA',
  'BVJ500101-2EA',
  'BVJ500301-10EA',
  'BVJ500301-2EA',
  'BVJ500302-10EA',
  'BVJ500302-2EA',
  'BVJ500303-10EA',
  'BVJ500303-2EA',
  'BVJ500343-10EA',
  'BVJ500343-2EA',
  'BVJ500344-10EA',
  'BVJ500403-10EA',
  'BVJ500403-2EA',
  'BVJ500404-10EA',
  'BVJ500404-2EA',
  'BVJ500503-10EA',
  'BVJ500503-2EA',
  'BVJ500504-10EA',
  'BVJ500504-2EA',
  'BVJ601613-10EA',
  'BVJ601633-10EA',
  'BVJ703102-10EA',
  'BVJ703102-3EA',
  'BVJ703103-10EA',
  'BVJ703103-3EA',
  'BVJ703104-10EA',
  'BVJ703104-3EA',
  'BVJ704102-2EA',
  'BVJ704102-6EA',
  'BVJ704103-2EA',
  'BVJ704103-6EA',
  'BVJ704104-2EA',
  'BVJ704104-6EA',
  'BVJA100112-2EA',
  'BVJA100114-2EA',
  'BVJA100138-2EA',
  'BVJA1011-2EA',
  'BVJA10112-3EA',
  'BVJA10134-3EA',
  'CSCVBNANCI150E0200-2EA',
  'CSCVBNANCI150E0250-2EA',
  'CVBNA100012LF075-5EA',
  'CVBNA100012LF100-2EA',
  'CVBNA100012LF100-5EA',
  'CVBNA100012LF125-2EA',
  'CVBNA100012LF150-2EA',
  'CVBNA100022LF075-5EA',
  'CVBNA100022LF100-2EA',
  'CVBNA100022LF100-5EA',
  'CVBNA100022LF125-2EA',
  'CVBNA100022LF150-2EA',
  'CVBNA100022LF200-2EA',
  'CVBNA100712LF050-5EA',
  'CVBNA100712LF075-5EA',
  'CVBNA100712LF100-2EA',
  'CVBNA100712LF125-2EA',
  'CVJ105003G-10EA',
  'CVJ105003G-2EA',
  'CVJ105004G-10EA',
  'CVJ105004G-2EA',
  'CVJ105103G-10EA',
  'CVJ105103G-5EA',
  'CVJ105104G-10EA',
  'CVJ105104G-5EA',
  'CVJ105105G-3EA',
  'CVJ105105G-6EA',
  'CVJ105106G-2EA',
  'CVJ105106G-5EA',
  'CVJ105107G-2EA',
  'CVJ105107G-4EA',
  'CVJ105203G-10EA',
  'CVJ105203G-5EA',
  'CVJ105204G-10EA',
  'CVJ105204G-5EA',
  'CVJ105205G-3EA',
  'CVJ105205G-6EA',
  'CVJ105206G-2EA',
  'CVJ105206G-5EA',
  'CVJ105207G-2EA',
  'CVJ105207G-4EA',
  'CVJ105303G-10EA',
  'CVJ105303G-3EA',
  'CVJ105304G-10EA',
  'CVJ105304G-2EA',
  'CVJ105305G-10EA',
  'CVJ105305G-2EA',
  'CVJ105403G-10EA',
  'CVJ105403G-3EA',
  'CVJ105404G-10EA',
  'CVJ105404G-2EA',
  'CVJ105405G-10EA',
  'CVJ105405G-2EA',
  'CVJ105603G-25EA',
  'CVJ105603G-5EA',
  'CVJ105604G-16EA',
  'CVJ105604G-4EA',
  'CVJ105605G-12EA',
  'CVJ105605G-3EA',
  'CVJ105606G-2EA',
  'CVJ105606G-9EA',
  'CVJ105607G-2EA',
  'CVJ105607G-8EA',
  'CVJ105613G-25EA',
  'CVJ105613G-5EA',
  'CVJ105614G-16EA',
  'CVJ105614G-4EA',
  'CVJ105615G-12EA',
  'CVJ105615G-3EA',
  'CVJ105616G-2EA',
  'CVJ105616G-6EA',
  'CVJ105617G-2EA',
  'CVJ105617G-4EA',
  'CVJ105623G-25EA',
  'CVJ105623G-4EA',
  'CVJ105624G-25EA',
  'CVJ105624G-3EA',
  'CVJ105625G-25EA',
  'CVJ105625G-2EA',
  'CVJ105626G-25EA',
  'CVJ105626G-2EA',
  'CVJ105633G-2EA',
  'CVJ105633G-4EA',
  'CVJ105634G-20EA',
  'CVJ105634G-3EA',
  'CVJ105635G-20EA',
  'CVJ105635G-2EA',
  'GVJ103303G-10EA',
  'GVJ103303G-5EA',
  'GVJ103304G-10EA',
  'GVJ103304G-3EA',
  'GVJ103305G-2EA',
  'GVJ103305G-5EA',
  'GVJ103306G-2EA',
  'GVJ103306G-5EA',
  'GVJ103307G-4EA',
  'GVJ103353G-3EA',
  'GVJ103353G-6EA',
  'GVJ103354G-2EA',
  'GVJ103354G-5EA',
  'GVJ103355G-2EA',
  'GVJ103355G-5EA',
  'GVJ103403G-10EA',
  'GVJ103403G-5EA',
  'GVJ103404G-10EA',
  'GVJ103404G-3EA',
  'GVJ103405G-2EA',
  'GVJ103405G-5EA',
  'GVJ103406G-2EA',
  'GVJ103406G-5EA',
  'GVJ103407G-4EA',
  'GVJ103453G-3EA',
  'GVJ103453G-6EA',
  'GVJ103454G-2EA',
  'GVJ103454G-5EA',
  'GVJ103455G-2EA',
  'GVJ103455G-5EA',
  'ORINGBV75007-170EA',
  'ORINGBV75010-170EA',
  'ORINGBV75011-170EA',
  'ORINGBV75012-100EA',
  'ORINGBV75017-75EA',
  'ORINGBV75203-50EA',
  'ORINGE70010-250EA',
  'ORINGE70011-250EA',
  'ORINGE70013-170EA',
  'ORINGE70114-85EA',
  'ORINGE70322-20EA',
  'ORINGN70005-500EA',
  'ORINGN70006-500EA',
  'ORINGN70007-500EA',
  'ORINGN70008-500EA',
  'ORINGN70009-500EA',
  'ORINGN70010-500EA',
  'ORINGN70011-500EA',
  'ORINGN70012-500EA',
  'ORINGN70013-500EA',
  'ORINGN70014-500EA',
  'ORINGN70015-500EA',
  'ORINGN70016-500EA',
  'ORINGN70017-250EA',
  'ORINGN70018-250EA',
  'ORINGN70027-170EA',
  'ORINGN70039-50EA',
  'ORINGN70104-500EA',
  'ORINGN70108-500EA',
  'ORINGN70109-250EA',
  'ORINGN70110-250EA',
  'ORINGN70111-250EA',
  'ORINGN70112-250EA',
  'ORINGN70113-250EA',
  'ORINGN70114-170EA',
  'ORINGN70115-170EA',
  'ORINGN70116-170EA',
  'ORINGN70118-125EA',
  'ORINGN70120-125EA',
  'ORINGN70123-100EA',
  'ORINGN70147-40EA',
  'ORINGN70149-40EA',
  'ORINGN70214-85EA',
  'ORINGN70215-85EA',
  'ORINGN70218-65EA',
  'ORINGN70220-60EA',
  'ORINGN70228-40EA',
  'ORINGN70229-35EA',
  'ORINGN70231-35EA',
  'ORINGN70252-15EA',
  'ORINGN70260-15EA',
  'ORINGN70902-500EA',
  'ORINGN90006-250EA',
  'ORINGN90012-500EA',
  'ORINGN90013-500EA',
  'ORINGN90014-250EA',
  'ORINGN90018-250EA',
  'ORINGN90023-170EA',
  'ORINGN90127-65EA',
  'ORINGN90213-75EA',
  'ORINGN90214-65EA',
  'ORINGN90217-60EA',
  'ORINGN90219-50EA',
  'ORINGN90220-50EA',
  'ORINGN90222-50EA',
  'ORINGN90230-25EA',
  'ORINGN90328-20EA',
  'ORINGN90334-15EA',
  'ORINGN90904-250EA',
  'ORINGQN70112-50EA',
  'ORINGQV75008-25EA',
  'ORINGQV75012-20EA',
  'ORINGQV75019-10EA',
  'ORINGS70006-500EA',
  'ORINGS70008-250EA',
  'ORINGS70009-250EA',
  'ORINGS70010-250EA',
  'ORINGS70011-250EA',
  'ORINGS70012-250EA',
  'ORINGS70022-100EA',
  'ORINGS70115-100EA',
  'ORINGS70119-75EA',
  'ORINGSN70011-250EA',
  'ORINGSN70014-170EA',
  'ORINGTURBOFUSE2-5EA',
  'ORINGV75006-170EA',
  'ORINGV75010-170EA',
  'ORINGV75011-170EA',
  'ORINGV75012-125EA',
  'ORINGV75016-75EA',
  'ORINGV75018-75EA',
  'ORINGV75019-60EA',
  'ORINGV75112-50EA',
  'ORINGV75226-10EA',
  'ORINGV75910-35EA',
  'ORINGV75916-20EA',
  'ORINGV90108-75EA',
  'ORINGV90222-10EA',
  'ORINGV90227-10EA',
  'ORINGV90228-10EA',
  'ORINGV90230-5EA',
  'PFBNA5V020004-20EA',
  'PFBNA5V020005-20EA',
  'PFBNA5V020006-10EA',
  'PFBNA5V020007-5EA',
  'PFBNA5V020008-3EA',
  'PFBNA5V020010-3EA',
  'PFBNA5V04000604-10EA',
  'PFBNA5V04000605-10EA',
  'PFBNA5V04000704-10EA',
  'PFBNA5V04000705-10EA',
  'PFBNA5V04000706-10EA',
  'PFBNA5V04000805-5EA',
  'PFBNA5V04000806-5EA',
  'PFBNA5V04000807-5EA',
  'PFBNA5V04001006-5EA',
  'PFBNA5V04001007-4EA',
  'PFBNA5V04001008-4EA',
  'PFBNA5V050004-20EA',
  'PFBNA5V050005-10EA',
  'PFBNA5V050006-10EA',
  'PFBNA5V050007-10EA',
  'PFBNA5V050008-4EA',
  'PFBNA5V050010-4EA',
  'PFBNA5V120004-30EA',
  'PFBNA5V120005-20EA',
  'PFBNA5V120006-10EA',
  'PFBNA5V120007-10EA',
  'PFBNA5V120008-5EA',
  'PFBNA5V120010-4EA',
  'PFBNA5V130004-30EA',
  'PFBNA5V130005-20EA',
  'PFBNA5V130006-10EA',
  'PFBNA5V130007-5EA',
  'PFBNA5V130008-3EA',
  'PFBNA5V140004-30EA',
  'PFBNA5V140005-20EA',
  'PFBNA5V140006-10EA',
  'PFBNA5V140007-5EA',
  'PFBNA5V140008-3EA',
  'PFBNA5V140010-2EA',
  'PFBNA5V150004-30EA',
  'PFBNA5V150005-20EA',
  'PFBNA5V150006-10EA',
  'PFBNA5V150007-5EA',
  'PFBNA5V150008-3EA',
  'PFBNA5V150010-2EA',
  'PFBNA5V320004-20EA',
  'PFBNA5V320005-10EA',
  'PFBNA5V320006-5EA',
  'PFBNA5V320007-4EA',
  'PFBNA5V320008-2EA',
  'PFBNA5V320010-2EA',
  'PFBNA5V3300050504-10EA',
  'PFBNA5V3300060604-5EA',
  'PFBNA5V3300060605-5EA',
  'PFBNA5V3300070704-4EA',
  'PFBNA5V3300070705-4EA',
  'PFBNA5V3300070706-4EA',
  'PFBNA5V3300080804-2EA',
  'PFBNA5V3300080805-2EA',
  'PFBNA5V3300080806-2EA',
  'PFBNA5V3300080807-2EA',
  'PFBNA5V3400050405-5EA',
  'PFBNA5V3400060406-5EA',
  'PFBNA5V3400060506-5EA',
  'PFBNA5V3500050404-5EA',
  'PFBNA5V3500060505-5EA',
  'PFBNA5V3500070606-2EA',
  'PFBNA5V3500080707-2EA',
  'PFBNA5V3600040405-5EA',
  'PFBNA5V49000504-10EA',
  'PFBNA5V49000604-10EA',
  'PFBNA5V49000605-10EA',
  'PFBNA5V49000705-3EA',
  'PFBNA5V49000706-4EA',
  'PFBNA5V49000805-3EA',
  'PFBNA5V49000806-3EA',
  'PFBNA5V49000807-3EA',
  'PFBNA5V49001005-3EA',
  'PFBNA5V49001006-2EA',
  'PFBNA5V49001007-2EA',
  'PFBNA5V49001008-3EA',
  'PFBNA5V530004-20EA',
  'PFBNA5V530005-10EA',
  'PFBNA5V530006-10EA',
  'PFBNA5V530007-5EA',
  'PFBNA5V530008-4EA',
  'PFBNA5V530010-3EA',
  'PFBSBMI45004-10EA',
  'PFBSBMI45005-10EA',
  'PFBSBMI45006-5EA',
  'PFBSBMI45023-10EA',
  'PFBSBMI45027-5EA',
  'PFBSBMI45028-5EA',
  'PFBSBMI45074-10EA',
  'PFBSBMI45075-10EA',
  'PFBSBMI45076-5EA',
  'PFBSBMI45084-5EA',
  'PFBSBMI45085-5EA',
  'PFBSBMI45104-5EA',
  'PFBSBMI45105-5EA',
  'PFBSBMI45106-5EA',
  'PFBSBMI45123-5EA',
  'PFBSBMI45127-5EA',
  'PFBSBMI45128-5EA',
  'PFBSBMI45204-10EA',
  'PFBSBMI45205-10EA',
  'PFBSBMI45206-5EA',
  'PFBSBMI45254-10EA',
  'PFBSBMI45255-10EA',
  'PFBSBMI45256-5EA',
  'PFBSBMI45304-10EA',
  'PFBSBMI45305-10EA',
  'PFBSBMI45306-5EA',
  'PFBSBMI45354-10EA',
  'PFBSBMI45355-10EA',
  'PFBSBMI45356-5EA',
  'PFBSBMI45404-5EA',
  'PFBSBMI45405-5EA',
  'PFBSBMI45406-5EA',
  'PFBSBMI45429-5EA',
  'PFBSBMI45438-5EA',
  'PFBSBMI45439-5EA',
  'PFBSBMI45504-10EA',
  'PFBSBMI45505-10EA',
  'PFBSBMI45506-5EA',
  'PFBSBMI45614-5EA',
  'PFBSBMI45615-5EA',
  'PFBSBMI45616-5EA',
  'PFBSBMI45630-5EA',
  'PFBSBMI45631-5EA',
  'PFBSBMI45640-5EA',
  'PFBSBMI45641-5EA',
  'PFBSBMI45704-10EA',
  'PFBSBMI45705-10EA',
  'PFBSBMI45706-5EA',
  'PFBSBMI45707-5EA',
  'PFBSBMI45723-10EA',
  'PFBSBMI45727-5EA',
  'PFBSBMI45728-10EA',
  'PFBSBMI45804-10EA',
  'PFBSBMI45805-10EA',
  'PFBSBMI45806-5EA',
  'PFBSBMI45807-5EA',
  'PFBSBMI46004-10EA',
  'PFBSBMI46005-10EA',
  'PFBSBMI46006-5EA',
  'PFBSBMI46023-5EA',
  'PFBSBMI46028-5EA',
  'PFBSBMI46074-10EA',
  'PFBSBMI46075-10EA',
  'PFBSBMI46076-5EA',
  'PFBSBMI46084-5EA',
  'PFBSBMI46085-5EA',
  'PFBSBMI46104-5EA',
  'PFBSBMI46105-5EA',
  'PFBSBMI46106-5EA',
  'PFBSBMI46123-5EA',
  'PFBSBMI46127-5EA',
  'PFBSBMI46128-5EA',
  'PFBSBMI46204-10EA',
  'PFBSBMI46205-10EA',
  'PFBSBMI46206-5EA',
  'PFBSBMI46254-10EA',
  'PFBSBMI46255-10EA',
  'PFBSBMI46256-5EA',
  'PFBSBMI46304-10EA',
  'PFBSBMI46305-10EA',
  'PFBSBMI46306-5EA',
  'PFBSBMI46354-10EA',
  'PFBSBMI46355-10EA',
  'PFBSBMI46356-5EA',
  'PFBSBMI46404-5EA',
  'PFBSBMI46405-5EA',
  'PFBSBMI46406-5EA',
  'PFBSBMI46429-5EA',
  'PFBSBMI46438-5EA',
  'PFBSBMI46439-5EA',
  'PFBSBMI46504-10EA',
  'PFBSBMI46505-10EA',
  'PFBSBMI46506-5EA',
  'PFBSBMI46614-5EA',
  'PFBSBMI46615-5EA',
  'PFBSBMI46616-5EA',
  'PFBSBMI46630-5EA',
  'PFBSBMI46631-5EA',
  'PFBSBMI46640-5EA',
  'PFBSBMI46641-5EA',
  'PFBSBMI46704-10EA',
  'PFBSBMI46705-10EA',
  'PFBSBMI46706-5EA',
  'PFBSBMI46707-5EA',
  'PFBSBMI46723-10EA',
  'PFBSBMI46727-5EA',
  'PFBSBMI46728-10EA',
  'PFBSBMI46804-10EA',
  'PFBSBMI46805-10EA',
  'PFBSBMI46806-5EA',
  'PFBSBMI46807-5EA',
  'PFCBMI47004-10EA',
  'PFCBMI47005-10EA',
  'PFCBMI47006-5EA',
  'PFCBMI47023-10EA',
  'PFCBMI47027-10EA',
  'PFCBMI47028-10EA',
  'PFCBMI47031-5EA',
  'PFCBMI47032-5EA',
  'PFCBMI47074-10EA',
  'PFCBMI47075-10EA',
  'PFCBMI47076-5EA',
  'PFCBMI47104-5EA',
  'PFCBMI47105-5EA',
  'PFCBMI47106-5EA',
  'PFCBMI47123-10EA',
  'PFCBMI47127-10EA',
  'PFCBMI47128-10EA',
  'PFCBMI47131-5EA',
  'PFCBMI47132-5EA',
  'PFCBMI47133-5EA',
  'PFCBMI47135-5EA',
  'PFCBMI47136-5EA',
  'PFCBMI47137-5EA',
  'PFCBMI47194-10EA',
  'PFCBMI47195-5EA',
  'PFCBMI47196-5EA',
  'PFCBMI47204-10EA',
  'PFCBMI47205-10EA',
  'PFCBMI47206-5EA',
  'PFCBMI47254-10EA',
  'PFCBMI47255-10EA',
  'PFCBMI47256-5EA',
  'PFCBMI47304-10EA',
  'PFCBMI47305-10EA',
  'PFCBMI47306-5EA',
  'PFCBMI47323-15EA',
  'PFCBMI47327-10EA',
  'PFCBMI47354-10EA',
  'PFCBMI47355-10EA',
  'PFCBMI47356-5EA',
  'PFCBMI47384-5EA',
  'PFCBMI47385-5EA',
  'PFCBMI47404-10EA',
  'PFCBMI47405-10EA',
  'PFCBMI47406-5EA',
  'PFCBMI47407-5EA',
  'PFCBMI47419-5EA',
  'PFCBMI47420-10EA',
  'PFCBMI47428-5EA',
  'PFCBMI47429-10EA',
  'PFCBMI47430-5EA',
  'PFCBMI47431-10EA',
  'PFCBMI47438-5EA',
  'PFCBMI47439-5EA',
  'PFCBMI47442-5EA',
  'PFCBMI47443-5EA',
  'PFCBMI47445-5EA',
  'PFCBMI47448-5EA',
  'PFCBMI47449-5EA',
  'PFCBMI47504-10EA',
  'PFCBMI47505-5EA',
  'PFCBMI47506-5EA',
  'PFCBMI47507-5EA',
  'PFCBMI47594-5EA',
  'PFCBMI47595-5EA',
  'PFCBMI47614-5EA',
  'PFCBMI47615-5EA',
  'PFCBMI47624-5EA',
  'PFCBMI47625-5EA',
  'PFCBMI47626-5EA',
  'PFCBMI47704-10EA',
  'PFCBMI47705-10EA',
  'PFCBMI47706-10EA',
  'PFCBMI47717-10EA',
  'PFCBMI47723-10EA',
  'PFCBMI47726-10EA',
  'PFCBMI47727-10EA',
  'PFCBMI47728-10EA',
  'PFCBMI47784-5EA',
  'PFCBMI47785-5EA',
  'PFCBMI47804-10EA',
  'PFCBMI47805-10EA',
  'PFCBMI47806-10EA',
  'PFCBMI47822-10EA',
  'PFCBMI47823-10EA',
  'PFCBMI47827-10EA',
  'PFCBMI47831-10EA',
  'PFCBMI47833-10EA',
  'PFCBMI47884-5EA',
  'PFCBMI47885-5EA',
  'PFCBMI47886-5EA',
  'PFCBMI47944-10EA',
  'PFCBMI47945-10EA',
  'PFCBMI47946-10EA',
  'PRMBECOPROPE151-24EA',
  'PRMBECOPROPE153-24EA',
  'PRMBECOPROPEWT151-24EA',
  'PRMBECOPROPEWT153-24EA',
  'PRMBECOPROPVC151-24EA',
  'PRMBECOPROPVCWT151-24EA',
  'PRMBECOPROPVCWT153-24EA',
  'PRMBECOPROPVCWT154-24EA',
  'PRMBECOPVC153H-24EA',
  'PRMBECOPVC154-24EA',
  'PRMBECOPVC154H-24EA',
  'PRMBECOPVC333-8EA',
  'PRMBECOPVC333H-8EA',
  'PRMBECOPVC701-24EA',
  'PRMBECOPVC703-24EA',
  'PRMBECOPVCWT153-24EA',
  'PRMBECOPVCWT154-24EA',
  'SSCVBNAS800025-2EA',
  'SSCVBNAS800038-2EA',
  'SSCVBNAS800050-2EA',
  'SSCVBNAS800075-2EA',
  'SSCVBNAS800100-2EA',
  'WC100G-10EA',
  'WC100G-50EA',
  'WC200G-10EA',
  'WC200G-50EA',
  'WC400G-10EA',
  'WC400G-50EA',
  'YSJ106303G-12EA',
  'YSJ106303G-3EA',
  'YSJ106304G-2EA',
  'YSJ106304G-8EA',
  'YSJ106305G-8EA',
  'YSJ106403G-12EA',
  'YSJ106403G-3EA',
  'YSJ106404G-2EA',
  'YSJ106404G-8EA',
  'YSJ106405G-8EA',
];
